import { render, staticRenderFns } from "./AnswerItem.vue?vue&type=template&id=73b42a04&scoped=true"
import script from "./AnswerItem.vue?vue&type=script&lang=ts"
export * from "./AnswerItem.vue?vue&type=script&lang=ts"
import style0 from "./AnswerItem.vue?vue&type=style&index=0&id=73b42a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b42a04",
  null
  
)

export default component.exports